/**
 * MessageRouterCase - Router for case-specific messages (/cases/:id/messages)
 */

import React from 'react';
import { Switch, useRouteMatch, Route } from 'react-router-dom';

import { MessageListPage, MessageDetailsPage } from './components';
import { MessageProvider } from './context';

function MessageRouterCase(props) {
  const { path } = useRouteMatch();

  return (
    <MessageProvider {...props} isFromCase>
      <Switch>
        <Route exact path={path} component={MessageListPage} />
        <Route path={`${path}/:message_id`} component={MessageDetailsPage} />
      </Switch>
    </MessageProvider>
  );
}

export default MessageRouterCase;
